import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export const DELIMITER = '/';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  fromModel = (value: string): NgbDateStruct | null => parseNgbDate(value);

  toModel = (date: NgbDateStruct | null): string => formatNgbDate(date, DELIMITER);
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse = (value: string): NgbDateStruct | null => parseNgbDate(value);

  format = (date: NgbDateStruct | null): string => formatNgbDate(date, DELIMITER);
}

export function parseNgbDate(value: string): NgbDateStruct | null {
  if (value) {
    const date: string[] = value.split(/[-/]+/);
    return {
      month: parseInt(date[0], 10),
      day: parseInt(date[1], 10),
      year: parseInt(date[2], 10)
    };
  }
  return null;
}

export function formatNgbDate(date: NgbDateStruct | null, DELIMITER: string): string {
  return date
    ? String(date.month).padStart(2, '0') +
        DELIMITER +
        String(date.day).padStart(2, '0') +
        DELIMITER +
        String(date.year).padStart(2, '0')
    : '';
}

export const VALIDATOR_INPUTS: readonly string[] = [
  'text',
  'textarea',
  'select',
  'checkbox',
  'radio',
  'date',
  'boolean',
  'file',
  'device_select',
  'line_select',
  'person_select',
  'password',
  'expiry_date',
  'string'
];

export const CUSTOM_FIELD_STYLES: { [k: string]: { [k: string]: string } } = {
  shipping_details: {
    city: 'col-lg-5 col-md-12',
    state: 'col-lg-4 col-md-6',
    zip: 'col-lg-3 col-md-6',
    shipping_method: 'col-lg-3 col-md-6'
  },
  service_area_details: {
    city: 'col-lg-5 col-md-12',
    state: 'col-lg-4 col-md-6',
    zip: 'col-lg-3 col-md-6',
    preferred_area_code: 'col-lg-3 col-md-6'
  },
  general: {
    city: 'col-lg-5 col-md-12',
    state: 'col-lg-4 col-md-6',
    zip: 'col-lg-3 col-md-6'
  },
  payment_details: {
    city: 'col-lg-6',
    state: 'col-lg-6',
    zip: 'col-lg-6',
    shipping_method: 'col-lg-6',
    'saved_card_attributes.cvv': 'col-lg-6',
    expiration_date: 'col-lg-6',
    cvv: 'col-lg-6'
  }
};

export const CUSTOM_DIVIDERS: { [k: string]: string[] } = {
  shipping_details: ['shipping_method'],
  service_area_details: ['preferred_area_code'],
  agreement: ['agreement_information_0'],
  payment_details: ['billing_address_readonly']
};

export const READONLY_LABEL: { [k: string]: string } = {
  shipping_details: 'Shipping Address',
  service_area_details: 'Preferred Area Location'
};

export const EMPTY_READONLY_TEMPLATES: { [k: string]: string[] } = {
  shipping_details: ['address1', 'address2', 'city', 'state', 'zip', 'company_name'],
  service_area_details: ['address1', 'address2', 'city', 'state', 'zip', 'company_name'],
  payment_details: ['credit_card.name_on_card', 'credit_card.expires', 'credit_card.card_type']
};

export const CUSTOM_DIRECTIVE: { [k: string]: { [k: string]: string } } = {
  payment_details: { number: 'number_only' }
};

export const HIDE_SELECT_ONE_OPTION: { [k: string]: string[] } = {
  agreement: ['locale']
};
